var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"editor-input border-bottom border-dark",staticStyle:{"border":"none"},attrs:{"type":"text","onkeypress":"this.style.width = ((this.value.length + 1) * 12) + 'px';"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }